"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestChatHandled =
/*#__PURE__*/
function (_pb_1$GuestChatHandle) {
  _inherits(ExtendedGuestChatHandled, _pb_1$GuestChatHandle);

  function ExtendedGuestChatHandled(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestChatHandled);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestChatHandled).call(this, properties));
    _this.type = ExtendedGuestChatHandled.type;
    _this.chreqid = properties.answer.request.proxy.chreqid;
    return _this;
  }

  _createClass(ExtendedGuestChatHandled, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.staff).concat(ExtendedGuestChatHandled.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestChatHandled.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestChatHandled(pb_1.GuestChatHandled.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestChatHandled;
}(pb_1.GuestChatHandled);

ExtendedGuestChatHandled.type = "GuestChatHandled";
ExtendedGuestChatHandled.context = "/guest-chat/handled";
exports.GuestChatHandled = ExtendedGuestChatHandled;